import { MessageCircle, Phone, Building2, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { WHATSAPP_LINK, PHONE_HREF } from "../data/site";
import { scrollToId } from "./shared";

export function Floating() {
  return (
    <>
      <motion.a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2.8, duration: 0.6 }}
        className="hidden md:flex fixed bottom-8 right-8 z-[64] items-center gap-3 pl-4 pr-5 py-3.5 rounded-full bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black shadow-[0_12px_40px_-10px_rgba(212,175,55,0.5)] hover:from-[#D4AF37] hover:to-[#F3E5AB] transition-colors group"
      >
        <MessageCircle size={18} />
        <span className="text-[11px] font-bold uppercase tracking-[0.15em]">Chat with a GYC Specialist</span>
      </motion.a>

      <nav
        data-testid="mobile-bottom-nav"
        className="md:hidden fixed bottom-0 inset-x-0 z-[64] bg-black/92 backdrop-blur-md border-t border-[#D4AF37]/25 grid grid-cols-4"
      >
        <a href={PHONE_HREF} data-testid="mobile-nav-call" className="flex flex-col items-center gap-1 py-3 text-[#A1A1AA] active:text-[#D4AF37]">
          <Phone size={17} /><span className="text-[9px] uppercase tracking-[0.18em]">Call</span>
        </a>
        <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="mobile-nav-whatsapp" className="flex flex-col items-center gap-1 py-3 text-[#A1A1AA] active:text-[#D4AF37]">
          <MessageCircle size={17} /><span className="text-[9px] uppercase tracking-[0.18em]">WhatsApp</span>
        </a>
        <button onClick={() => scrollToId("inventory")} data-testid="mobile-nav-properties" className="flex flex-col items-center gap-1 py-3 text-[#A1A1AA] active:text-[#D4AF37]">
          <Building2 size={17} /><span className="text-[9px] uppercase tracking-[0.18em]">Properties</span>
        </button>
        <button onClick={() => scrollToId("site-visit")} data-testid="mobile-nav-visit" className="flex flex-col items-center gap-1 py-3 text-[#A1A1AA] active:text-[#D4AF37]">
          <MapPin size={17} /><span className="text-[9px] uppercase tracking-[0.18em]">Site Visit</span>
        </button>
      </nav>
    </>
  );
}
